var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('SocketMessage'),(_vm.isShowDeepSeekHelper)?_c('deep-seek-helper'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }